export const COPILIT_SETTING_SELECTION_TYPES = {
  ALL: 'all',
  REGEX: 'regex',
  CUSTOM: 'custom'
};
